let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7mJtW")).then(() => parcelRequire('2vldl'));